module.exports = __webpack_public_path__ + "img/spinneys-original-1920.af9324a6.webp";